import {Injectable} from "@angular/core";
import {Constants} from "./constants";

@Injectable()
export class EndpointsService {
  baseUrl: string = Constants.SERVER_URL();

  getProfileUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'applicationProfile';
    return this.baseUrl + 'applicationProfile?' + value;
  }

  getCurrentUserProfiles() {
    return this.baseUrl + 'applicationProfile/by-current-user';
  }

  getAppVisibilityUrl() {
    return this.getProfileUrl() + "/set-visibility";
  }

  getRequestAppApprovalUrl() {
    return this.getProfileUrl() + "/request-approval";
  }

  getApproveAppForResellerUrl() {
    return this.getProfileUrl() + "/approve-app";
  }

  getAppProfileStatusUrl() {
    return this.baseUrl + 'appProfileStatus';
  }

  getLoginUrl() {
    return this.baseUrl + 'api/login';
  }

  getSignUpUrl() {
    return this.baseUrl + 'signup/signup';
  }

  getUserActivateUrl() {
    return this.baseUrl + 'signup/activate';
  }

  getUploadFileUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'applicationProfile/upload';
    return this.baseUrl + 'applicationProfile/upload?' + value;
  }

  getRFQAttachmentUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'billing/upload-rfq-attachment';
    return this.baseUrl + 'billing/upload-rfq-attachment?' + value;
  }

  getRFQUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'billing/save-rfq';
    return this.baseUrl + 'billing/save-rfq?' + value;
  }

  getRFQListUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'buyer/rfqs';
    return this.baseUrl + 'buyer/rfqs?' + value;
  }

  getResellerRFQListUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'reseller/rfqs';
    return this.baseUrl + 'reseller/rfqs?' + value;
  }

  getResellerQuotationListUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'reseller/quotes';
    return this.baseUrl + 'reseller/quotes?' + value;
  }

  getVendorQuotationListUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'vendor/quotes';
    return this.baseUrl + 'vendor/quotes?' + value;
  }

  getVendorPendingQuotationListUrl() {
    return this.baseUrl + 'vendor/pending-quotes';
  }

  getVendorRespondToQuoteUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'vendor/update-quote-status';
    return this.baseUrl + 'vendor/update-quote-status?' + value;
  }

  getQuoteUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'billing/save-quote';
    return this.baseUrl + 'billing/save-quote?' + value;
  }

  getQuoteUpdateUrl() {
    return this.baseUrl + 'quotation';
  }

  getQuoteAttachmentUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'billing/upload-quote-attachment';
    return this.baseUrl + 'billing/upload-quote-attachment?' + value;
  }

  getincrementProfileViewsUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'applicationProfile/incrementProfileViews';
    return this.baseUrl + 'applicationProfile/incrementProfileViews?' + value;
  }

  getApplicationCategoryUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'applicationCategory/listApprovedCategories';
    return this.baseUrl + 'applicationCategory/listApprovedCategories?' + value;
  }

  getAllTenantsUrl() {
    return this.baseUrl + 'tenants';
  }

  getTenantUrl() {
    return this.baseUrl + 'tenant';
  }

  getCategoriesUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'applicationCategory';
    return this.baseUrl + 'applicationCategory?' + value;
  }

  addToApprovedCategoriesUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'applicationCategory/addToApprovedCategories';
    return this.baseUrl + 'applicationCategory/addToApprovedCategories?' + value;
  }

  removeFromApprovedCategoriesUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'applicationCategory/removeFromApprovedCategories';
    return this.baseUrl + 'applicationCategory/removeFromApprovedCategories?' + value;
  }

  getPricingPlansUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'applicationProfile/pricingPlans';
    return this.baseUrl + 'applicationProfile/pricingPlans?' + value;
  }

  getPlaceOrderUrl(value: string = null) {
    if (!value)
      return this.baseUrl + 'buyer/placeOrder';
    return this.baseUrl + 'buyer/placeOrder?' + value;
  }

  getUserUrl() {
    return this.baseUrl + "user"
  }

  getUpdatePasswordUrl() {
    return this.getUserUrl() + "/update-password";
  }

  getUserAccountStatusUrl() {
    return this.getUserUrl() + "/status";
  }

  getUserRequestTerminateAccountUrl() {
    return this.getUserUrl() + "/request-terminate";
  }

  getInProgressSignUpUrl() {
    return this.baseUrl + 'signup/inprogress';
  }

  getCurrentUserUrl() {
    return this.baseUrl + "user/current"
  }

  getResellerProgramsUrl() {
    return this.baseUrl + "appResellerProgram";
  }

  getResellerByDomainUrl(value: string) {
    if (!value)
      return this.baseUrl + 'reseller/getByTenant';
    return this.baseUrl + 'reseller/getByTenant?' + value;
  }

  getApplicationProfileSearchUrl() {
    return this.getProfileUrl() + "/search";
  }

  getAllCategoriesUrl() {
    return this.baseUrl + 'applicationCategory/getAllCategories';
  }

  getForgotPasswordUrl() {
    return this.baseUrl + "user/request-reset-password"
  }

  getResetPasswordUrl() {
    return this.baseUrl + "user/reset-password"
  }

  getTenantByCurrentLoggedInUser() {
    return this.baseUrl + "tenant/by-current-user"
  }

  getCheckoutSecretKeyUrl() {
    return this.baseUrl + "tenant/checkout-secret-key"
  }

  getNotificationUrl() {
    return this.baseUrl + "notification";
  }

  getNotificationListUrl() {
    return this.getNotificationUrl() + "/list";
  }

  getUnReadNotificationCountUrl() {
    return this.getNotificationUrl() + "/count-unread";
  }

  getMarkAsReadNotificationUrl() {
    return this.getNotificationUrl() + "/mark-as-read";
  }

  getBuyerRFQUrl() {
    return this.baseUrl + "reseller/rfqs"
  }

  getRequestForQuoteUrl() {
    return this.baseUrl + 'requestForQuotation';
  }

  getIsBookmarkedUrl() {
    return this.baseUrl + 'bookmark/is-bookmarked';
  }

  getApprovedReseller() {
    return this.baseUrl + 'reseller/is-approved';
  }

  getBookmarkUrl(profileId?: number) {
    if (profileId) {
      return this.baseUrl + `bookmark/${profileId}`;
    } else {
      return this.baseUrl + 'bookmark';
    }
  }

  getResellerProgramRequestStatus() {
    return this.baseUrl + 'reseller-program-request-status';
  }

  getPricingPlanWithIdUrl() {
    return this.baseUrl + 'pricingPlan';
  }

  sendEmailNotificationUrl() {
    return this.baseUrl + 'notification/send-email';
  }

  getIPAddressUrl() {
    return this.baseUrl + 'signup/get-client-ip-address';
  }

  getSendEmailUrl() {
    return this.baseUrl + 'send-email';
  }

  getLeadUrl() {
    return this.baseUrl + 'lead';
  }

  getLeadsUrl(status: string = 'PENDING', id: string = '') {
    return this.baseUrl + 'lead?id=' + id + '&status=' + status;
  }

  getCustomersUrl() {
    return this.baseUrl + 'customers';
  }

  getSpecificPricingPlansUrl() {
    return this.baseUrl + 'pricing-plans';
  }
}



// WEBPACK FOOTER //
// ./src/app/services/endpoints.service.ts